import React from 'react';
import PropTypes from 'prop-types';
import Tagger from './Tagger';
import LocalizedStrings from './localization.js';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class TaggerModal extends React.Component {
    _focusElement;

    constructor(props) {
        super(props);
        this.state = {
            tags: []
        };

        //BINDINGS
        this.close = this.close.bind(this);
        this.handlePositiveClick = this.handlePositiveClick.bind(this);
        this.handleAddTag = this.handleAddTag.bind(this);
        this.handleDeleteTag = this.handleDeleteTag.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.open !== prevProps.open) {
            setTimeout(() => {
                if (this._focusElement) {
                    this._focusElement.focus();
                }
            }, 100);
        }
    }

    close() {
        this.props.handleClose();
    }

    handlePositiveClick() {
        this.close();

        this.props.handleYes(this.state.tags);
        this.setState({ tags: [] });
    }

    handleAddTag = (values) => {
        let tags = [];
        values.forEach((currVal) => {
            if (tags.indexOf(currVal) === -1) {
                tags.push(currVal.value);
            }
        });
        this.setState({ tags });
    }

    handleDeleteTag(tag) {
        this.setState({
            tags: this.state.tags.filter(t => t !== tag),
        });
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.close}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"

            >
                <DialogTitle id="alert-dialog-title">
                    {LocalizedStrings.tagSelected}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {LocalizedStrings.pleaseTagSelection}
                    </DialogContentText>
                    {this.props.open === true && <Tagger
                        usePortal={true}
                        takeRef={c => {
                            this._focusElement = c;
                        }}
                       
                        onResultSelected={this.handleAddTag} />}
                    <DialogContentText id="alert-dialog-description">
                        {LocalizedStrings.tagSelectedNote}
                    </DialogContentText>

                </DialogContent>
                <DialogActions>
                    <Button onClick={this.close} color="primary">
                        {LocalizedStrings.cancel}
                    </Button>
                    <Button onClick={this.handlePositiveClick} color="primary" autoFocus>
                        {LocalizedStrings.confirm}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
};

TaggerModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleYes: PropTypes.func.isRequired,
   
};

export default TaggerModal;